<template>
  <div class="bg-darkmode-important" style="background-color: #f5f6fa; border-radius: 0 0 5px 0">
    <div class="flex-1 pr-30">
      <h6 class="strong">{{ $t("text.booking_settings_for_inline") }}</h6>
      <p class="font-body">{{ $t("text.customize_the_booking_page_look") }}</p>

      <div class="my-10 mt-20">
        <Checkbox :label="$t('text.hide_event_details')" :labelable="true" :isChecked="s_hide" @checkboxChange="s_hide = !s_hide" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.background_color") }}</h6>
        <SelectColor v-model="s_bg" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.text_color") }}</h6>
        <SelectColor v-model="s_text" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.button_link_color") }}</h6>
        <SelectColor v-model="s_link" />
      </div>
    </div>
    <div class="flex-1">
      <h6 class="strong">{{ $t("text.embed_code") }}</h6>
      <h6>{{ $t("text.place_html_weezly_appear") }}</h6>

      <textarea readonly class="code-display my-15" style="height: 276px; word-break: break-all">{{ htmlCode }}</textarea>

      <div class="align-right">
        <button class="btn btn-primary font-h6" v-ripple @click="copyCode">{{ $t("button.copy_code") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import SelectColor from "@/components/Scheduling/Events/SelectColor";
import { copyClipboard } from "@/helpers/functions.js";
export default {
  name: "ShareInline",
  components: {
    SelectColor,
  },
  props: {},
  data: function () {
    return {
      s_hide: false,
      s_bg: "#FFFFFF",
      s_text: "#000000",
      s_link: "#0090FF",
    };
  },
  computed: {
    settings() {
      return this.$store.getters.getSchedulingSettings;
    },
    htmlCode() {
      return `<!-- ${this.$Brand} inline widget begin -->
<iframe src="${this.external_link}/${this.settings.link}?type=embed&hide_detail=${
        this.s_hide
      }&s_bg=${this.s_bg.substring(1)}&s_text=${this.s_text.substring(1)}&s_link=${this.s_link.substring(
        1
      )}" style="width: 100%; min-height: 640px;border: 0;"></iframe>
<!-- ${this.$Brand} inline widget end -->`;
    },
  },
  async mounted() {},
  methods: {
    copyCode() {
      copyClipboard(this.htmlCode);
      this.$root.$emit("alert", this.$t("alert.code_copied"));
    },
  },
};
</script>
